import { required, useRecordContext } from 'react-admin';
import { StateInput, CountyInput } from '@/pages/Candidate/view/inputs';
import { DefaultToolbarStyled } from '@/styles/overrides';
import { NationalRecord } from '@/types/turn-api';
import { path } from './constants';
import { FormContentProps } from './types';

const FormContent = ({ onClose, ...props }: FormContentProps) => {
  const record = useRecordContext();

  return (
    <>
      <StateInput disabled={true} include_prefix={false} label="State" source={path('state')} validate={required()} />
      <CountyInput state={record?.state} validate={required()} />

      <DefaultToolbarStyled onClose={() => onClose(record as NationalRecord)} {...props} />
    </>
  );
};

export default FormContent;
